module.exports = __webpack_public_path__ + "static/media/Block by Block_20191010_135558183465469.dea22d94.jpg";